// extracted by mini-css-extract-plugin
export default {"dataList":"Styles_dataList__nMkVu","dataItem":"Styles_dataItem__c1KJK"};